var _path, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0064AD",
    d: "M0 0h26v17H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFD300"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0h5v17H8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6h26v5H0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#Da0e15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0h2v17H9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7.5h26v2H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAx);
export default __webpack_public_path__ + "static/media/ax.310c28a965ba16376e38f237b87ecd1e.svg";
export { ForwardRef as ReactComponent };